import { MenuItem, Select } from "@mui/material";
import * as Styled from './style';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

type Option = {
	label: string;
	value: string;
};

type BaseSelectProps = {
	value: string;
	onChange: (value: string) => void;
	placeholder: string;
	options: Option[];
	disabled?: boolean;
	label?: string;
	disabledLayers?: string[];
	displayIcon?: boolean;
	tooltipeMessage?: string;
}

const menuItemStyles = {
	display: 'block',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
};

export function BaseSelect({ value, onChange, placeholder, options, disabled, label, disabledLayers = [], displayIcon, tooltipeMessage }: BaseSelectProps) {
	return (
		<Styled.BaseSelectWrapper>
			{label && <label>{label}</label>}

			<div className="select-container">
				<Select
					value={value}
					onChange={(e) => onChange(e.target.value)}
					displayEmpty
					variant="outlined"
					MenuProps={{
						PaperProps: {
							sx: {
								width: 0,
								maxWidth: '100%'
							}
						}
					}}
					disabled={disabled}
				>
					<MenuItem value="disable" sx={menuItemStyles}>
						{placeholder}
					</MenuItem>

					{options.map((option: Option) => {
						const isDisabled = disabledLayers.includes(option.value);
						return (
							<MenuItem
								key={`option-value-${option.value}`}
								value={option.value}
								sx={menuItemStyles}
								disabled={isDisabled}
							>
								{option.label}
							</MenuItem>
						);
					})}
				</Select>

				{displayIcon && (
					<InfoOutlinedIcon
						titleAccess={tooltipeMessage}
						fontSize="large"
						className="info-icon"
						sx={{
							cursor: 'pointer',
							opacity: 1,
							transition: '0.2s',
							'&:hover': {
								opacity: 0.5,
							}
						}}
					/>
				)}
			</div>
		</Styled.BaseSelectWrapper>
	)
}